import {SODeleteExportProject} from '../../core/export-project/so-delete-export-project';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteExportProject extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteExportProject;
}